<template>
  <el-table
    :data="tableData"
    stripe
    style="width: 100%"
    height="200px"
    max-height="500px"
  >
    <el-table-column
      prop="waybillNo"
      label="运单编号"
      width="130"
      align="center"
    >
    </el-table-column>
    <el-table-column prop="orderNo" label="订单编号" width="180" align="center">
    </el-table-column>
    <el-table-column
      prop="dispatchOrderNo"
      label="调度订单号"
      width="180"
      align="center"
    >
    </el-table-column>
    <el-table-column
      prop="v_bizStatus"
      label="业务状态"
      width="80"
      align="center"
    >
    </el-table-column>
    <el-table-column
      prop="carrierName"
      label="承运商名称"
      width="120"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column
      prop="driverName"
      label="司机姓名"
      width="100"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column prop="driverMobile" label="司机手机号" width="110">
    </el-table-column>
    <el-table-column prop="vehicleNo" label="车牌号" width="100" align="center">
    </el-table-column>

    <el-table-column
      prop="assistant"
      label="跟车员"
      width="100"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column prop="assistantMobile" label="跟车员手机" width="110">
    </el-table-column>

    <el-table-column
      prop="pickupPointName"
      label="发货方"
      width="120"
      show-overflow-tooltip
    >
    </el-table-column>

    <el-table-column prop="pickupProvinceName" label="发货省份" width="100">
    </el-table-column>
    <el-table-column prop="pickupCityName" label="发货城市" width="100">
    </el-table-column>
    <el-table-column prop="pickupDistrictName" label="发货区县" width="100">
    </el-table-column>
    <el-table-column
      prop="pickupAddress"
      label="发货地址"
      width="150"
      show-overflow-tooltip
    >
    </el-table-column>

    <el-table-column prop="pickupContactName" label="发货方联系人" width="100">
    </el-table-column>
    <el-table-column
      prop="pickupContactMobile"
      label="发货方手机号"
      width="110"
    >
    </el-table-column>
    <el-table-column
      prop="pickupContactPhone"
      label="发货方固定电话"
      width="110"
    >
    </el-table-column>
    <el-table-column
      prop="pickupRemark"
      label="发货方备注"
      width="120"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column
      prop="receivePointName"
      label="收货方"
      width="120"
      show-overflow-tooltip
    >
    </el-table-column>

    <el-table-column prop="receiveProvinceName" label="收货省份" width="100">
    </el-table-column>
    <el-table-column prop="receiveCityName" label="收货城市" width="100">
    </el-table-column>
    <el-table-column prop="receiveDistrictName" label="收货区县" width="100">
    </el-table-column>
    <el-table-column
      prop="receiveAddress"
      label="收货地址"
      width="150"
      show-overflow-tooltip
    >
    </el-table-column>

    <el-table-column prop="receiveContactName" label="收货方联系人" width="100">
    </el-table-column>
    <el-table-column
      prop="receiveContactMobile"
      label="收货方手机号"
      width="110"
    >
    </el-table-column>
    <el-table-column
      prop="receiveContactPhone"
      label="收货方固定电话"
      width="110"
    >
    </el-table-column>
    <el-table-column prop="receiveContactEmail" label="收货方邮箱" width="110">
    </el-table-column>
    <el-table-column
      prop="receiveRemark"
      label="收货方备注"
      width="120"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column
      prop="v_transportMode"
      label="运输模式"
      width="80"
      align="center"
    >
    </el-table-column>
    <el-table-column
      prop="v_orderType"
      label="订单类型"
      width="80"
      align="center"
    >
    </el-table-column>
    <el-table-column
      prop="goodsShowName"
      label="货物集合"
      width="200"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column prop="totQty" label="总件数" width="110">
    </el-table-column>
    <el-table-column prop="totPayWeight" label="总重量（公斤）" width="110">
    </el-table-column>
    <el-table-column prop="totPayVolume" label="总体积（立方）" width="110">
    </el-table-column>
    <el-table-column prop="totValue" label="总货值" width="110">
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
